<template>
    <v-container  class="align-start mt-3">
        <v-row align="center">
            <v-col align="center">
                <h3>{{ player? player.name: "" }}</h3>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <elo-chart :chartData="elos" :labels="dates"></elo-chart>

            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import EloChart from '../components/EloChart'
import { format } from 'date-fns'
    export default {
        name: "Player",
        components: {
            EloChart                
        },
        data() {
            return {
                player: null,
                elos: [],
                dates: []
            }
        },
        methods: {
            getElos(){
                let season = 0
                if(this.elos.length == 0){
                    this.player = this.$store.state.players.find(item => item.id == this.$route.params.id)                        
                    let myGames = this.allGames.filter(a => a.players.find((item) => item.id == this.$route.params.id) != undefined)       
                    if(myGames.length > 0) {
                        this.elos.push(1500)
                        this.dates.push(format(new Date(myGames[0].date), 'dd.MM.yyyy'))  
                        season = myGames[0].season           
                    }
                    for(let game of myGames){                            
                        let temp = game.players.find(item => item.id == this.player.id)
                        if(temp && temp.elo){
                            if(game.season != season){
                                this.elos.push(temp.elo)
                                this.dates.push(format(new Date(game.date), 'dd.MM.yyyy') + ' Season decay')
                                season = game.season
                            }
                            let win = temp.team == 1 && game.team1_score == 2 || temp.team == 2 && game.team2_score == 2 ? 1 : -1
                            this.elos.push(Math.floor(temp.elo + game.eloRaw*win))
                            this.dates.push(format(new Date(game.date), 'dd.MM.yyyy'))
                        } 
                    }
                    if(this.elos.length)
                        this.elos[this.elos.length - 1] = this.player.score
                }
            }
        },
        mounted(){
            this.getElos()
        },
        watch: {
            allGames: {
                deep: true,
                handler(){                    
                    this.getElos()
                }
            }
        },
        computed: {
            ...mapGetters(['allGames']),
        }
    }
</script>

<style lang="scss" scoped>

</style>